// extracted by mini-css-extract-plugin
module.exports = {"link":"MetaversePreviewLink_link__3SOKa","text":"MetaversePreviewLink_text__2z_yR"};